module.exports = __webpack_public_path__ + "static/media/docTemplate_icon.e4bcb032.svg";